"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = decodeJWT;

function decodeJWT(string) {
  var base64Url = string.split('.')[1];
  var base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(Buffer.from(base64, 'base64').toString('binary'));
}